// src/utils/useBlockNavigation.ts
import { useEffect } from "react";
import { Modal } from "antd";
import { useHistory } from "react-router-dom";

export function useBlockNavigation(when: boolean) {
  const history = useHistory();

  useEffect(() => {
    if (!when) return;

    const unblock = history.block((tx) => {
      Modal.confirm({
        title: "Bạn có thay đổi chưa lưu",
        content: "Rời trang sẽ làm mất dữ liệu. Bạn có chắc muốn rời đi?",
        okText: "Rời đi",
        cancelText: "Ở lại",
        onOk: () => {
          unblock(); // bỏ block
          history.push(tx.pathname); // tiếp tục điều hướng
        },
      });

      return false; // chặn lại
    });

    return () => {  
      unblock();
    };
  }, [when, history]);
}
